var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  d: "M12 1.2c5.965 0 10.8 4.835 10.8 10.8 0 5.964-4.835 10.8-10.8 10.8-5.964 0-10.8-4.836-10.8-10.8S6.036 1.2 12 1.2M9.056 5.847a.36.36 0 0 0-.545.308v11.689c0 .28.305.453.545.309l9.74-5.844a.36.36 0 0 0 0-.618z"
}))));
export default SvgPlayIcon;